import React, { Component } from 'react';
import _ from 'lodash';
import { Sparklines, SparklinesLine } from 'react-sparklines';
import PortfolioWeight from '../components/portfolio-weight.js'
import PortfolioGains from '../components/portfolio-gains.js'
import StatLegend from '../components/stat.js'
import axios from 'axios';
import SymbolLink from '../components/symbol-link.js'
import { db } from '../firebase';

export default class History extends Component {

    constructor() {
        super();
        this.state = {
            positions: [],
            charts: [],
            today: false
        }
    }

    async componentDidMount() {

        let items = await db.getPosition();
        items = _.orderBy(items.filter(a => a.gains != 0), "gains", "desc");
        let total_fees = _.sumBy(items, "fees");
        let total_dividend = _.sumBy(items, "dividends");
        let total_gain = _.sumBy(items, "gains");

        let max_gain = _.maxBy(items, 'gains').gains;

        this.setState({
            positions: items,
            fees: total_fees,
            dividends: total_dividend,
            gains: total_gain + total_dividend - total_fees,
            max_gain: max_gain
        });
    }

    render() {

        if (this.state.positions && this.state.positions.length) {

            let max_gain = this.state.max_gain;
            return (
                <div className="ss-container-stacked ss-page">
                    <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                        <div class="navbar-brand">
                            <a class="navbar-item">
                                <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                            </a>
                        </div>
                        <div className="navbar-start">
                            <div className="navbar-item">
                                <div>
                                    <p className="title is-4">History</p>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <div className="ss-fluid-row">
                        <div className="section" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                            <div class="columns">
                                {this.state.gains &&
                                    <div class="column">
                                        <StatLegend
                                            color={this.state.gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                            value={'$' + (this.state.gains).toFixed(2)}
                                            label="Net Gains" />
                                    </div>}

                                {this.state.dividends &&
                                    <div class="column">
                                        <StatLegend
                                            color={this.state.dividends > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                            value={'$' + (this.state.dividends).toFixed(2)}
                                            label="Dividends" />
                                    </div>}
                                {this.state.fees &&
                                    <div class="column">
                                        <StatLegend
                                            color={this.state.fees > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                            value={'$' + (this.state.fees).toFixed(2)}
                                            label="Commisions & Fees" />
                                    </div>}
                            </div>
                        </div>

                        <section className="section" style={{ backgroundColor: "rgb(245, 245, 245)" }} >
                            <div className="card">
                                <table className="table table is-narrow is-fullwidth table is-hoverable ">
                                    <thead>
                                        <th>Symbol</th>
                                        <th><span className="is-pulled-right">Fees ($)</span></th>
                                        <th><span className="is-pulled-right">Dividends ($)</span></th>
                                        <th><span className="is-pulled-right">Gains ($)</span></th>
                                        <th><span className="is-pulled-right">Net Gains($)</span></th>
                                        <th style={{ "width": "200px" }}></th>
                                    </thead>
                                    <tbody>
                                        {this.state.positions.map(function (pos_item, i) {

                                            let net_gains = pos_item.dividends ? (pos_item.gains + pos_item.dividends - pos_item.fees) : (pos_item.gains - pos_item.fees);
                                            let gain_ratio = (100 * Math.abs(net_gains / max_gain)) + '%';
                                            let background_color = net_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)";
                                            return <tr>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <i className={"fa fa-circle " + (net_gains > 0 ? "has-text-success" : "has-text-danger")} aria-hidden="true" style={{ marginRight: "0.75em" }}></i>
                                                    <SymbolLink symbol={pos_item.symbol} />
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right">{pos_item.fees ? ('$' + pos_item.fees.toFixed(2)) : '-'}</span>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right">{pos_item.dividends ? ('$' + pos_item.dividends.toFixed(2)) : '-'}</span>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right">${pos_item.gains.toFixed(2)}</span>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right">${net_gains.toFixed(2)}</span>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <div style={{ "width": gain_ratio, "height": "32px", backgroundColor: background_color }} />
                                                </td>

                                            </tr>
                                        })}
                                    </tbody>

                                </table>
                            </div>
                        </section >
                    </div>
                </div>)
        }
        else {
            return <div></div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/history.js